import React, { useState } from 'react';
import { Phone, Mail, MapPin, Shield, FileText, Lock, Users, Clock } from 'lucide-react';
import { companyInfo } from '../data/mock';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';

const companyLogo = "https://customer-assets.emergentagent.com/job_sleuth-focsani-clone/artifacts/0lecfb0n_Detectiv%20Bacau.jpg";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

  const links = [
    { href: '#acasa', label: 'Acasă' },
    { href: '#servicii', label: 'Servicii' },
    { href: '#despre', label: 'Despre Noi' },
    { href: '#contact', label: 'Contact' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full overflow-hidden">
                <img src={companyLogo} alt="Logo" className="w-full h-full object-cover" />
              </div>
              <span className="text-white font-semibold">{companyInfo.name}</span>
            </div>
            <p className="text-slate-500 text-sm">
              Detectivi particulari Bacau — Investigații profesionale, discrete și legale în județul Bacău și la nivel național.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-medium mb-4">Navigație</h4>
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-slate-500 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-medium mb-4">Contact</h4>
            <div className="space-y-2 text-sm">
              <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2 text-slate-500 hover:text-white transition-colors">
                <Phone className="w-4 h-4" />
                {companyInfo.phone}
              </a>
              <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 text-slate-500 hover:text-white transition-colors">
                <Mail className="w-4 h-4" />
                {companyInfo.email}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 pt-6 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-600 text-xs">
            © {currentYear} CABINET INDIVIDUAL DETECTIV PARTICULAR ENE D. GABRIEL • CUI: 29837817
          </p>
          <Dialog open={isPrivacyOpen} onOpenChange={setIsPrivacyOpen}>
            <DialogTrigger asChild>
              <button className="text-slate-600 hover:text-slate-400 transition-colors text-xs">
                Politica de Confidențialitate
              </button>
            </DialogTrigger>
            <DialogContent className="max-w-3xl max-h-[85vh] bg-slate-900 border-slate-700 p-0">
              <DialogHeader className="p-6 pb-0">
                <DialogTitle className="text-xl font-semibold text-white">Politica de Confidențialitate</DialogTitle>
              </DialogHeader>
              <ScrollArea className="h-[65vh] p-6">
                <div className="prose prose-invert prose-sm max-w-none">
                  <div className="bg-slate-800/50 rounded-lg p-4 mb-6">
                    <p className="text-slate-300 text-sm"><strong>Operator:</strong> CABINET INDIVIDUAL DETECTIV PARTICULAR ENE D. GABRIEL</p>
                    <p className="text-slate-300 text-sm"><strong>CUI:</strong> 29837817</p>
                    <p className="text-slate-300 text-sm"><strong>Contact:</strong> {companyInfo.email}</p>
                  </div>
                  
                  <h3 className="text-white text-base font-medium mt-6 mb-2">1. Date Colectate</h3>
                  <p className="text-slate-400 text-sm">Colectăm: nume, email, telefon și mesajul transmis prin formularul de contact.</p>
                  
                  <h3 className="text-white text-base font-medium mt-6 mb-2">2. Temei Legal</h3>
                  <p className="text-slate-400 text-sm">Prelucrăm datele conform Art. 6 GDPR (contract/interes legitim) și Legii 329/2003 privind exercitarea profesiei de detectiv particular.</p>
                  
                  <h3 className="text-white text-base font-medium mt-6 mb-2">3. Durata Stocării</h3>
                  <p className="text-slate-400 text-sm">Date contact: 3 ani. Dosare investigații: 5 ani (Legea 329/2003). Documente fiscale: 10 ani.</p>
                  
                  <h3 className="text-white text-base font-medium mt-6 mb-2">4. Drepturile Dvs.</h3>
                  <p className="text-slate-400 text-sm">Aveți dreptul de acces, rectificare, ștergere și restricționare. Contact: {companyInfo.email}</p>
                  
                  <h3 className="text-white text-base font-medium mt-6 mb-2">5. Transfer Date</h3>
                  <p className="text-slate-400 text-sm">Nu vindem și nu comercializăm datele dvs. către terți.</p>
                </div>
              </ScrollArea>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
